exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinnerBox.center{position:absolute;left:50%;top:50%}.spinnerBox.placeholder{display:block;position:relative;text-align:center;padding:50px}.spinnerBox.placeholder .spinner{left:50%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/spinner.scss
// module id = 907
// module chunks = 0